/* eslint-disable no-dupe-keys */
export default {
  invoice: {
    name: '开票记录',
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '申请单号',
      process_number: '工单号',
      order_trade_number: '订单号',
      evcs_operator: '渠道商',
      service_provider: '运营商',
      trade_number: '订单号',
      evcs_seq: '互联互通编号',
      phone: '用户手机',
      user: '用户',
      user_info: '用户信息',
      charge_station: '开票场站',
      applied_amount: '申请金额',
      orders_amount: '订单原金额',
      orders_count: '订单数',
      electric_amount: '电费',
      service_amount: '服务费',
      invoice_title_type: '抬头类型',
      invoice_title: '发票抬头',
      invoice_taxpayer_number: '纳税人识别号',
      company_address: '公司地址',
      company_mobile: '公司电话',
      taxpayer_opening_bank: '开户银行',
      card_number: '银行卡号',
      address: '企业地址',
      receive_email: '邮箱',
      status: '状态',
      order_source: '订单来源',
      attachment: '附件',
      processing_time: '处理时长',
      applied_at: '申请时间',
      invoiced_at: '开票时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      internal_remark: '内部备注'
    },
    // Enum的属性
    attribute_maps: {
      evcs_xingluo: '星络',
      evcs_xindiantu: '新电途',
      evcs_kuaidian: '快电'
    },
    invoice_title_types: {
      individual: '个人',
      enterprise: '企业'
    },
    statuses: {
      pending: '未开票',
      done: '已开票',
      cancelled: '已取消'
    },
    order_sources: {
      ecmp: '我方订单',
      evcs: '第三方订单'
    },
    // Boolean的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    list_tabs: {
      all: '全部',
      pending: '未开票',
      done: '已开票',
      cancelled: '已取消'
    },
    btns: {
      import_invoice: '导入开票申请',
      export_invoice: '导出开票记录',
      export_invoice_attachment: '导出开票附件',
      upload_invoice: '上传发票',
      cancel_invoice: '取消发票',
      view_invoice: '查看发票',
      invoicing: '批量开票',
      change_invoice_to_pending: '重开发票',
      notify_now: '立即通知'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      orders_info: '订单明细',
      invoice_info: '开票信息',
      invoice_apply_info: '发票抬头信息'
    },
    import_invoice_dialog: {
      title: '导入发票申请',
      attribute_map: '属性映射',
      // order_info: '订单明细',
      import_file: '导入文件',
      btns: {
        confirm_import: '确认导入'
      },
      toast: {
        import_success: '导入成功'
      }
    },
    upload_invoice_dialog: {
      title: '上传发票',
      is_upload_attachment: '上传附件',
      is_send_email: '邮件通知',
      placeholder: {
        input_internal_remark: '请输入内部备注'
      },
      toast: {
        upload_success: '上传成功'
      }
    },
    cancel_invoice_dialog: {
      placeholder: {
        input_internal_remark: '请输入内部备注'
      },
      toast: {
        cancel_succeed: '取消成功'
      }
    },
    tips: {
      confirm_done_selected: '确认批量开票当前已选中的记录？',
      change_invoice_to_pending_succeed: '撤回开票成功',
      no_invoice_mobile: '当前运营商尚未设置开票专员。设置开票专员后，有申请会及时通知，可以提升开票效率。',
      has_invoice_mobile: '开票专员手机 {0} ，每天定时通知开票。'
    }
  }
}
